import { useQuery } from "@tanstack/react-query";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";

import { NavbarApp } from "../../../components";
import { getProfile } from "../../../data";
import AuthStore from "../../../stores/AuthStore";
import { cn } from "@/lib/utils";

export const FullScreenLayout = (props) => {
  const contentPadding = "px-4 md:px-6 lg:px-8";
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setSidebarVisible(
      window.__SIDEBAR_VISIBLE !== undefined ? window.__SIDEBAR_VISIBLE : true
    );
    const handler = (event) => {
      if (event?.detail?.isVisible !== undefined) {
        setSidebarVisible(event.detail.isVisible);
      }
    };
    window.addEventListener("sidebar-visibility-change", handler);
    return () => window.removeEventListener("sidebar-visibility-change", handler);
  }, []);

  const contentOffset = isSidebarVisible ? "md:pl-72 lg:pl-80" : "md:pl-0";

  return (
    <div className="min-h-screen bg-background">
      <NavbarApp />
      <main className={cn("w-full pb-10", contentPadding, contentOffset)}>
        {props.loading && (
          <div>
            <h1>Yükleniyor...</h1>
          </div>
        )}
        {props.children}
      </main>
    </div>
  );
};
